/* eslint-disable import/prefer-default-export */
import { ApplicationUserDto, ApplicationUserModel } from 'api/types';
import { apiPaths } from 'config/apiPaths';

import { dtoToApplicationUserModel } from './mappers/application-user.mappers';
import axios from './axios';

export enum SearchUserType {
  Application = 'Application',
  Card = 'Card',
}

export const getApplicationUsers = async (
  search: string,
  searchUserType?: SearchUserType,
): Promise<ApplicationUserModel[]> => {
  return axios
    .get<ApplicationUserDto[]>(apiPaths.APPLICATION_USERS_PATH, { params: { search, searchUserType } })
    .then((response) => response.data.map((item) => dtoToApplicationUserModel(item)));
};
